import { MessageBoxIcon } from "@/domains/common/components/message-box-icon"
import { MultilineMessageBox } from "@/domains/common/components/multi-line-message-box"
import { BodyXs } from "@/domains/design/components/body-xs"

export const TransferVotedPanel = () => {
  return (
    <MultilineMessageBox variant={"error"} icon={<MessageBoxIcon size={"sm"} variant="error" />}>
      <BodyXs className="text-error-text">You cannot transfer NFTs that have already voted this epoch.</BodyXs>
    </MultilineMessageBox>
  )
}
